<template>
  <RefundsReportFilter @export="exportReport" />
</template>
<script>
import RefundsReportFilter from './components/refundsReportFilter.vue';

import reportsApi from '../../../../services/reports.api';
import functions from '../../../../utils/functions';
import notify from '../../../../utils/notify';

export default {
  name: 'RefundsReport',
  components: { RefundsReportFilter },
  methods: {
    async exportReport(filters) {
      try {
        this.$vs.loading();
        const buffer = await reportsApi.exportRefundsReport(filters);
        const now = functions.formataDataMomentJS(
          new Date().toISOString(),
          'DD-MM-YYYY HH:mm',
        );

        const fileName = `Relatório Restituições - ${now}.xlsx`;
        await functions.downloadFromBuffer(window, buffer, fileName);
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
  },
};
</script>
